






































































































import {
  Prop,
  Vue,
  Component
} from "@/shared/vuepack";


@Component
export default class SideBar extends Vue {
  @Prop() addExpenseAction: (event?: any) => void;
  @Prop() displayPersonalExpenseTracker: boolean;
  @Prop() showMyExpensesHowItWorks: boolean;
  @Prop() showFindExpensesHowItWorks: boolean;

  fullView = true;

  onClick (): void {
    this.fullView = !this.fullView;
  }
}
